import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@dev-go4ellis/go4-design-system';
import './FooterCTA.scss';

const FooterCTA = ({ onPrimaryCTA, onSecondaryCTA }) => (
  <section className="pl-footer-cta">
    <div className="pl-footer-cta__inner">
      <h2 className="pl-footer-cta__title">
        You've seen the number. Now fill the shift.
      </h2>
      <p className="pl-footer-cta__subtitle">
        Posting is free and takes a few minutes. Trainers in your area see
        it immediately.
      </p>

      <div className="pl-footer-cta__buttons">
        <Button variant="secondary" size="lg" onClick={onSecondaryCTA}>
          Re-run my estimate
        </Button>
        <Button variant="primary" size="lg" onClick={onPrimaryCTA}>
          Post a job free →
        </Button>
      </div>

      <div className="pl-footer-cta__legal">
        <div className="pl-footer-cta__brand">
          Go<span className="pl-footer-cta__brand-accent">4</span>
        </div>
        <p className="pl-footer-cta__legal-copy">
          © 2026 Go4. All rights reserved. Service fee shown is 17.5% of trainer
          pay. Rates shown are historical averages, not quotes.
        </p>
      </div>
    </div>
  </section>
);

FooterCTA.propTypes = {
  onPrimaryCTA: PropTypes.func.isRequired,
  onSecondaryCTA: PropTypes.func.isRequired,
};

export default FooterCTA;
